module.exports = "/packs/images/svg/facilities/building_facilities~486a2d11a9dcd9d3a8790ca9c014cc6a.svg";